import { GetAccountBalanceResult, GetReloadAccountBalanceConfigResult, PaymentProviderEnum } from '../api';
import { AppErrorKeys } from '../errors/error';
import { getErrorResponse } from './common';

const MOCK_ACCOUNT_BALANCE_OK: GetAccountBalanceResult = {
  accountBalance: -3, //Math.round(Math.random() * 100),
};

const MOCK_ACCOUNT_BALANCE_NOSOLD: GetAccountBalanceResult = {
  accountBalance: undefined,
};

export const MOCK_ACCOUNT_BALANCE = {
  OK: MOCK_ACCOUNT_BALANCE_OK,
  KO: getErrorResponse(AppErrorKeys.CaisseUnavailable),
  NO_SOLD: MOCK_ACCOUNT_BALANCE_NOSOLD,
};

const MOCK_RELOAD_ACCOUNT_BALANCE_CONFIG_OK: GetReloadAccountBalanceConfigResult = {
  paymentProviders: [
    { id: 3, label: 'Carte de crédit', provider: PaymentProviderEnum.WorldLine },
    { id: 99, label: 'Ticket restaurant', provider: <any>'TR' },
  ],
  allowedAmounts: [1, 10, 20, 50, 100, 200],
};

export const MOCK_RELOAD_ACCOUNT_BALANCE_CONFIG = {
  OK: MOCK_RELOAD_ACCOUNT_BALANCE_CONFIG_OK,
  KO: getErrorResponse(AppErrorKeys.DeactivatedPayment),
};

export const MOCK_RELOAD_ACCOUNT_BALANCE = {
  KO: getErrorResponse(AppErrorKeys.DeactivatedPayment),
};
